function srgbToLinear(c: number): number {
  const s = c / 255
  return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4)
}

function relativeLuminance(r: number, g: number, b: number): number {
  return 0.2126 * srgbToLinear(r) + 0.7152 * srgbToLinear(g) + 0.0722 * srgbToLinear(b)
}

function contrastRatio(l1: number, l2: number): number {
  const lighter = Math.max(l1, l2)
  const darker = Math.min(l1, l2)
  return (lighter + 0.05) / (darker + 0.05)
}

const LIGHT_TEXT = '#ffffff'
const DARK_TEXT = '#1f2937'

const LIGHT_TEXT_LUMINANCE = relativeLuminance(255, 255, 255)
const DARK_TEXT_LUMINANCE = relativeLuminance(31, 41, 55)

export function getContrastTextColor(hex: string): string {
  const raw = hex.replace('#', '').slice(0, 6)
  if (raw.length < 6) return LIGHT_TEXT

  const r = parseInt(raw.slice(0, 2), 16)
  const g = parseInt(raw.slice(2, 4), 16)
  const b = parseInt(raw.slice(4, 6), 16)

  const bgLum = relativeLuminance(r, g, b)
  const lightContrast = contrastRatio(LIGHT_TEXT_LUMINANCE, bgLum)
  const darkContrast = contrastRatio(bgLum, DARK_TEXT_LUMINANCE)

  return lightContrast > darkContrast ? LIGHT_TEXT : DARK_TEXT
}
